import { Injector, NgModule } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RouterModule, Routes } from '@angular/router';

import { ClientConfigProductName, ProductService } from '@frontend/vanilla/core';
import player from 'lottie-web';
import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';

import { CASINO_INTERNAL_ROUTES } from './casino-internal.routes';
import { provideCasinoHostApp } from './host-app/casino-host-app.provider';
import { casinoProductActivateGuard, casinoProductDeactivateGuard } from './route-guards';

export const CASINO_ROUTES: Routes = [
    {
        path: '',
        canMatch: [casinoProductActivateGuard],
        canDeactivate: [casinoProductDeactivateGuard],
        children: [
            // ToDo: As of now we are passing same internal routes to sub lobbies like livecasino. We need to refactore it.
            ...CASINO_INTERNAL_ROUTES,
            {
                path: 'livecasino',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'arcade',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'coinarcade',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'gameshows',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'livegames',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'betgames',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'games',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'casinogames',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'providers',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'slingo',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'slotsandgames',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'slots',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'onlineslots',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'roulette',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'blackjack',
                children: [...CASINO_INTERNAL_ROUTES],
            },
            {
                path: 'scratchandinstant',
                children: [...CASINO_INTERNAL_ROUTES],
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(CASINO_ROUTES)],
    providers: [
        provideCasinoHostApp(),
        provideLottieOptions({
            player: () => player,
        }),
        provideCacheableAnimationLoader(),
        provideAnimationsAsync(),
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: {} },
    ],
})
export class CasinoRoutesModule {
    constructor(injector: Injector) {
        injector.get(ProductService).register(ClientConfigProductName.CASINO, injector);
    }
}
